import axios from '@/utils/axios';
import { isAuthenticated } from '@/utils/auth';
import {createRouter, createWebHistory} from 'vue-router';
import NotificationService from '@/services/NotificationService'

import dashboardIndex from '@/views/pages/dashboard/dashboard-index.vue';
import applicationIndex from '@/views/pages/applications/application-index.vue';
import chatIndex from '@/views/pages/applications/chat-index.vue';
import voiceCall from '@/views/pages/applications/calls/voice-call.vue';
import videoCall from '@/views/pages/applications/calls/video-call.vue';
import outgoingCall from '@/views/pages/applications/calls/outgoing-call.vue';
import incomingCall from '@/views/pages/applications/calls/incoming-call.vue';
import callHistory from '@/views/pages/applications/calls/call-history.vue';
import calendarIndex from '@/views/pages/applications/calendar-index.vue';
import emailIndex from '@/views/pages/applications/email-index.vue';
import emailReply from '@/views/pages/applications/email-reply.vue';

//CUSTOM ROUTES
import ModuleList from '@/views/pages/superadmin/module.vue';
import RolePermission from '@/views/pages/superadmin/role-permission.vue';
import Admin from '@/views/pages/superadmin/admin.vue';
import SubAdmin from '@/views/pages/user/subadmin.vue';
import Industries from '@/views/pages/superadmin/industries.vue';
import DocumentTemplates from '@/views/pages/superadmin/document-templates.vue';

import Crmcompanies from '@/views/pages/superadmin/companies/companies-crm.vue';
import companiesDetails from '@/views/pages/superadmin/companies/companies-details.vue';
import superSubscription from '@/views/pages/superadmin/super-subscription.vue';
import clientsGrid from '@/views/pages/projects/clients/clients-grid.vue';
import clientsList from '@/views/pages/projects/clients/clients-list.vue';
import clientsDetails from '@/views/pages/projects/clients/clients-details.vue';
import todoList from '@/views/pages/applications/todo-list.vue';
import todoIndex from '@/views/pages/applications/todo-index.vue';

import leadsDetails from '@/views/pages/crm/leads/leads-details.vue';
import leadsGrid from '@/views/pages/crm/leads/leads-grid.vue';
import leadsList from '@/views/pages/crm/leads/leads-list.vue';
import importCsv from '@/views/pages/crm/leads/import-csv.vue';
import importIndiamart from '@/views/pages/crm/leads/import-indiamart.vue';
import importTradeindia from '@/views/pages/crm/leads/import-tradeindia.vue';
import importAajjo from '@/views/pages/crm/leads/import-aajjo.vue';
import importExportersIndia from '@/views/pages/crm/leads/import-exportersindia.vue';

import projects from '@/views/pages/workspace/projects.vue';
import projectDetails from '@/views/pages/workspace/project-details.vue';
import tasks from '@/views/pages/workspace/tasks.vue';

import todaysFollowup from '@/views/pages/crm/leads/todays-followup.vue';

import customers from '@/views/pages/crm/customers/customers.vue';
import customersDetails from '@/views/pages/crm/customers/customers-details.vue';
import itemGroups from '@/views/pages/crm/items/item-groups.vue';
import items from '@/views/pages/crm/items/items.vue';
import importItemCsv from '@/views/pages/crm/items/import-csv.vue';
import subscriptions from '@/views/pages/crm/customers/subscriptions.vue';
import customerDispatches from '@/views/pages/crm/customers/customer-dispatches.vue';
import siteInspections from '@/views/pages/crm/site-inspections/site-inspections.vue';

import proposals from '@/views/pages/sales/proposals.vue';
import viewProposal from '@/views/pages/sales/view-proposal.vue';
import quotations from '@/views/pages/sales/quotations.vue';
import viewQuotation from '@/views/pages/sales/view-quotation.vue';
import previewQuotation from '@/views/pages/sales/preview-quotation.vue';

import previewProforma from '@/views/pages/sales/preview-proforma-invoice.vue';
import proformaInvoice from '@/views/pages/sales/proforma-invoices.vue';
import viewProformaInvoice from '@/views/pages/sales/view-proforma-invoice.vue';

import previewInvoice from '@/views/pages/sales/preview-invoice.vue';
import invoice from '@/views/pages/sales/invoices.vue';
import viewInvoice from '@/views/pages/sales/view-invoice.vue';

import payment from '@/views/pages/finance-accounts/payments.vue';
import paymentLink from '@/views/pages/finance-accounts/payment-links.vue';
import zohoPayment from '@/views/pages/finance-accounts/zoho/zoho-payments.vue';
import importZohoPayment from '@/views/pages/finance-accounts/zoho/import-csv.vue';
import zohoPaymentHistory from '@/views/pages/finance-accounts/zoho/zoho-payment-history.vue';

import sampling from '@/views/pages/finance-accounts/samplings.vue';
import salesOrder from '@/views/pages/finance-accounts/sales-orders.vue';
import viewPackagingList from '@/views/pages/finance-accounts/view-packaging-list.vue';

// #############################################################################
//         ************************ INVENTORY ********************
// #############################################################################

import vendor from '@/views/pages/inventory/vendors.vue'; 
import warehouse from '@/views/pages/inventory/warehouses.vue';
import purchaseOrder from '@/views/pages/inventory/purchase-orders.vue';
import viewPurchaseOrder from '@/views/pages/inventory/view-purchase-order.vue';
import inwardStock from '@/views/pages/inventory/inward-stock.vue';
import importInventory from '@/views/pages/inventory/import-csv.vue';
import warehouseItem from '@/views/pages/inventory/warehouse-items.vue';
import pendingVariance from '@/views/pages/inventory/pending-variances.vue';
import lowStock from '@/views/pages/inventory/low-stock.vue';
import deliveryChallan from '@/views/pages/inventory/delivery-challans.vue';
import viewDeliveryChallan from '@/views/pages/inventory/view-delivery-challan.vue';
import workOrders from '@/views/pages/inventory/work-orders.vue';
import deliveryChallanReturn from '@/views/pages/inventory/delivery-challan-returns.vue';

import userSummaryReport from '@/views/pages/reports/users/summary.vue';
import userDetailedReport from '@/views/pages/reports/users/detailed.vue';

import leadSummaryReport from '@/views/pages/reports/leads/summary.vue';
import leadDetailedReport from '@/views/pages/reports/leads/detailed.vue';

import quotationSummaryReport from '@/views/pages/reports/quotations/summary.vue';
import quotationDetailedReport from '@/views/pages/reports/quotations/detailed.vue';

import samplingDetailedReport from '@/views/pages/reports/samplings/detailed.vue';
import salesOrderDetailedReport from '@/views/pages/reports/sales-orders/detailed.vue';
import paymentDetailedReport from '@/views/pages/reports/payments/detailed.vue';

import employeesIndex from '@/views/pages/hrm/employees/employees-index.vue';
import employeesList from '@/views/pages/hrm/employees/employees-list.vue';
import employeesGrid from '@/views/pages/hrm/employees/employees-grid.vue';
import employeeDetails from '@/views/pages/hrm/employees/employee-details.vue';
import employeeDepartment from '@/views/pages/hrm/employees/employee-department.vue';
import employeeDesignations from '@/views/pages/hrm/employees/employee-designations.vue';
import employeePolicy from '@/views/pages/hrm/employees/employee-policy.vue';
import ticketList from '@/views/pages/hrm/tickets/tickets-list.vue';
import ticketsIndex from '@/views/pages/hrm/tickets/tickets-index.vue';
import ticketsGrid from '@/views/pages/hrm/tickets/tickets-grid.vue';
import ticketsDetails from '@/views/pages/hrm/tickets/tickets-details.vue';
import accountingIndex from '@/views/pages/finance-accounts/accounting/accounting-index.vue';
import budgetsIndex from '@/views/pages/finance-accounts/accounting/budgets-index.vue';
import budgetsExpenses from '@/views/pages/finance-accounts/accounting/budgets-expenses.vue';
import budgetsRevenues from '@/views/pages/finance-accounts/accounting/budgets-revenues.vue';
import payrollIndex from '@/views/pages/finance-accounts/payroll/payroll-index.vue';
import employeeSalary from '@/views/pages/finance-accounts/payroll/employee-salary.vue';
import payslipIndex from '@/views/pages/finance-accounts/payroll/payslip-index.vue';
import payrollAdditions from '@/views/pages/finance-accounts/payroll/payroll-additions.vue';
import payrollOvertime from '@/views/pages/finance-accounts/payroll/payroll-overtime.vue';
import payrollDeduction from '@/views/pages/finance-accounts/payroll/payroll-deduction.vue';
import assetsIndex from '@/views/pages/administration/assets/assets-index.vue';
import assetsList from '@/views/pages/administration/assets/assets-list.vue';
import assetsCategories from '@/views/pages/administration/assets/assets-categories.vue';
import helpSupports from '@/views/pages/administration/supports/help-supports.vue';
import knowledgebaseIndex from '@/views/pages/administration/supports/knowledgebase-index.vue';
import knowledgebaseView from '@/views/pages/administration/supports/knowledgebase-view.vue';
import knowledgebaseDetails from '@/views/pages/administration/supports/knowledgebase-details.vue';

import businessSettings from '@/views/pages/administration/settings/general-settings/business-settings.vue';
import bankDetails from '@/views/pages/administration/settings/general-settings/bank-details.vue';
import branchDetails from '@/views/pages/administration/settings/general-settings/branch-details.vue';

import LeadStage from '@/views/pages/administration/settings/crm-settings/lead-stages.vue';
import LeadSource from '@/views/pages/administration/settings/crm-settings/lead-sources.vue';
import LeadAssignmentRule from '@/views/pages/administration/settings/crm-settings/lead-assignment-rule.vue';
import LeadAssignmentLocationRule from '@/views/pages/administration/settings/crm-settings/lead-assignment-location-rule.vue';
import ProjectPipeline from '@/views/pages/administration/settings/crm-settings/project-pipelines.vue';

import Tax from '@/views/pages/administration/settings/financial-settings/taxes.vue';

import configuration from '@/views/pages/administration/settings/others-settings/configurations.vue';
import UserRolePermission from '@/views/pages/administration/settings/others-settings/role-permission.vue';
import WhatsappFollowupTemplates from '@/views/pages/administration/settings/others-settings/whatsapp-followup-templates.vue';
import Brands from '@/views/pages/administration/settings/others-settings/brands.vue';
import Engineer from '@/views/pages/administration/settings/others-settings/engineer.vue';
import salesExecutives from '@/views/pages/administration/settings/others-settings/sales-executives.vue';
import internalConsumptions from '@/views/pages/administration/settings/others-settings/internal-consumptions.vue';
import siteInspectors from '@/views/pages/administration/settings/others-settings/site-inspectors.vue';
import storePersons from '@/views/pages/administration/settings/others-settings/store-person.vue';
import installationPersons from '@/views/pages/administration/settings/others-settings/installation-persons.vue';


import appStore from '@/views/pages/administration/settings/app-settings/app-store.vue';

import proposalSetting from '@/views/pages/administration/settings/document-settings/proposal-settings.vue';
import quotationSetting from '@/views/pages/administration/settings/document-settings/quotation-settings.vue';
import proformaSetting from '@/views/pages/administration/settings/document-settings/proforma-settings.vue';
import invoiceSetting from '@/views/pages/administration/settings/document-settings/invoice-settings.vue';
import salesOrderSettings from '@/views/pages/administration/settings/document-settings/sales-order-settings.vue';
import samplingSettings from '@/views/pages/administration/settings/document-settings/sampling-settings.vue';

import websiteSettings from '@/views/pages/administration/settings/website-settings/website-settings.vue';
import seoSettings from '@/views/pages/administration/settings/website-settings/seo-settings.vue';
import localizationSettings from '@/views/pages/administration/settings/website-settings/localization-settings.vue';
import prefixes from '@/views/pages/administration/settings/website-settings/prefixes-settings.vue';
import preferences from '@/views/pages/administration/settings/website-settings/preferences-settings.vue';
import appearance from '@/views/pages/administration/settings/website-settings/appearance-settings.vue';
import authenticationSettings from '@/views/pages/administration/settings/website-settings/authentication-settings.vue';
import aiSettings from '@/views/pages/administration/settings/website-settings/ai-settings.vue';
import systemSettings from '@/views/pages/administration/settings/system-settings/system-settings.vue';
import emailSettings from '@/views/pages/administration/settings/system-settings/email-settings.vue';
import emailTemplate from '@/views/pages/administration/settings/system-settings/email-template.vue';
import smsSettings from '@/views/pages/administration/settings/system-settings/sms-settings.vue';
import smsTemplate from '@/views/pages/administration/settings/system-settings/sms-template.vue';
import otpSettings from '@/views/pages/administration/settings/system-settings/otp-settings.vue';
import gdprSettings from '@/views/pages/administration/settings/system-settings/gdpr-settings.vue';
import maintenanceMode from '@/views/pages/administration/settings/system-settings/maintenance-mode.vue';

import currenciesSettings from '@/views/pages/administration/settings/financial-settings/currencies-settings.vue';

import customJs from '@/views/pages/administration/settings/others-settings/custom-js.vue';
import cronJob from '@/views/pages/administration/settings/others-settings/cronjob-settings.vue'
import cronjobSchedule from '@/views/pages/administration/settings/others-settings/cronjob-schedule.vue'
import storageSettings from '@/views/pages/administration/settings/others-settings/storage-setings.vue';
import banIpAddress from '@/views/pages/administration/settings/others-settings/ban-ip-address.vue';
import backupSettings from '@/views/pages/administration/settings/others-settings/backup-settings.vue';
import clearCache from '@/views/pages/administration/settings/others-settings/clear-cache.vue';
import notesIndex from '@/views/pages/applications/notes-index.vue';
import socialFeed from '@/views/pages/applications/social-feed.vue';
import invoicesApp from '@/views/pages/applications/invoices-app.vue';
import addInvoices from '@/views/pages/applications/add-invoices.vue';
import editInvoices from '@/views/pages/applications/edit-invoices.vue';
import invoiceDetails from '@/views/pages/applications/invoice-details.vue';
import fileManager from '@/views/pages/applications/file-manager/file-manager.vue';
import kanbanView from '@/views/pages/applications/kanban-view/kanban-view.vue';
import pagesIndex from '@/views/pages/pages/pages-index.vue';
import starterIndex from '@/views/pages/pages/starter-index.vue';
import profileIndex from '@/views/pages/pages/profile-index.vue';
import Notification from '@/views/pages/applications/notifications.vue';
import galleryIndex from '@/views/pages/pages/gallery-index.vue';
import searchResult from '@/views/pages/pages/search-result.vue';
import timelineIndex from '@/views/pages/pages/timeline-index.vue';
import pricingIndex from '@/views/pages/pages/pricing-index.vue';
import comingSoon from '@/views/pages/pages/coming-soon.vue';
import underMaintenance from '@/views/pages/pages/under-maintenance.vue';
import underConstruction from '@/views/pages/pages/under-construction.vue';
import apiKeys from '@/views/pages/pages/api-keys.vue';
import privacyPolicy from '@/views/pages/pages/privacy-policy.vue';
import termsCondition from '@/views/pages/pages/terms-condition.vue';

import layoutIndex from '@/views/pages/layout/layout-index.vue';
import layoutHorizontal from '@/views/pages/layout/layout-horizontal.vue';
import layoutDetached from '@/views/pages/layout/layout-detached.vue';
import layoutModern from '@/views/pages/layout/layout-modern.vue';
import layoutTwocolum from '@/views/pages/layout/layout-two-column.vue';
import layoutHovered from '@/views/pages/layout/layout-hovered.vue';
import layoutBox from '@/views/pages/layout/layout-box.vue';
import layoutHorizontalSingle from '@/views/pages/layout/layout-horizontal-single.vue';
import layoutHorizontalOverlay from '@/views/pages/layout/layout-horizontal-overlay.vue';
import layoutHorizontalBox from '@/views/pages/layout/layout-horizontal-box.vue';
import layoutHorizontalSidemenu from '@/views/pages/layout/layout-horizontal-sidemenu.vue';
import layoutVerticalTransparent from '@/views/pages/layout/layout-vertical-transparent.vue';
import layoutWithoutHeader from '@/views/pages/layout/layout-without-header.vue';
import layoutRtl from '@/views/pages/layout/layout-rtl/layout-rtl.vue';
import layoutDark from '@/views/pages/layout/layout-dark.vue';


import Tables from '@/views/pages/uiinterface/tables/ui-tables'
import Tables_Basic from '@/views/pages/uiinterface/tables/tables-basic.vue'
import Data_Tables from '@/views/pages/uiinterface/tables/data-tables.vue'
import Chartapex from '@/views/pages/uiinterface/charts/apex/chart-apex.vue'
import Chartc3 from '@/views/pages/uiinterface/charts/c3/chart-c3.vue'
import Chartflot from '@/views/pages/uiinterface/charts/flot/chart-flot.vue'
import Chartjs from '@/views/pages/uiinterface/charts/js/chart-js.vue'
import Chartmorris from '@/views/pages/uiinterface/charts/morris/chart-morris.vue'
import Charts from '@/views/pages/uiinterface/charts/ui-charts.vue'
import Forms from '@/views/pages/uiinterface/forms/ui-forms.vue'
import Formbasicinput from '@/views/pages/uiinterface/forms/form-elements/formbasic/formbasic-input.vue'
import Formcheckboxradios from '@/views/pages/uiinterface/forms/form-elements/form-checkbox-radios.vue'
import Formgridgutters from '@/views/pages/uiinterface/forms/form-elements/form-grid-gutters.vue'
import Formselect from '@/views/pages/uiinterface/forms/form-elements/form-select.vue'
import FormInput from '@/views/pages/uiinterface/forms/form-elements/forminput/form-input.vue'
import Formmask from '@/views/pages/uiinterface/forms/form-elements/formmask/formmask.vue'
import Formfileupload from '@/views/pages/uiinterface/forms/form-elements/formfile-upload.vue'
import FormHorizontal from '@/views/pages/uiinterface/forms/layouts/form-horizontal.vue'
import Formvertical from '@/views/pages/uiinterface/forms/layouts/form-vertical.vue'
import Formfloatinglabels from '@/views/pages/uiinterface/forms/layouts/form-floating-labels.vue'
import Formvalidation from '@/views/pages/uiinterface/forms/form-validation.vue'
import Formselect2 from '@/views/pages/uiinterface/forms/form-select2.vue'
import FormElements from '@/views/pages/uiinterface/forms/form-elements/form-elements.vue'
import Formwizard from '@/views/pages/uiinterface/forms/form-wizard.vue'
import Advancedui from '@/views/pages/uiinterface/advancedUI/advanced-ui.vue'
import UI_Ribbon from '@/views/pages/uiinterface/advancedUI/ui-ribbon.vue'
import UI_Clipboard from '@/views/pages/uiinterface/advancedUI/ui-clipboard.vue'
import UI_Drag_Drop from '@/views/pages/uiinterface/advancedUI/ui-drag-drop.vue'
import UI_Text_Editor from '@/views/pages/uiinterface/advancedUI/ui-text-editor.vue'
import UI_Counter from '@/views/pages/uiinterface/advancedUI/ui-counter.vue'
import UI_Scrollbar from '@/views/pages/uiinterface/advancedUI/ui-scrollbar.vue'
import UI_Rating from '@/views/pages/uiinterface/advancedUI/ui-rating.vue'
import UI_Stickynote from '@/views/pages/uiinterface/advancedUI/ui-stickynote.vue'
import UI_Timeline from '@/views/pages/uiinterface/advancedUI/ui-timeline.vue'
import BaseUi from '@/views/pages/uiinterface/baseui/base-ui.vue'
import UI_Alerts from '@/views/pages/uiinterface/baseui/ui-alerts.vue'
import UI_Accordion from '@/views/pages/uiinterface/baseui/ui-accordion.vue'
import UI_Avatar from '@/views/pages/uiinterface/baseui/ui-avatar.vue'
import UI_Badges from '@/views/pages/uiinterface/baseui/ui-badges.vue'
import UI_Borders from '@/views/pages/uiinterface/baseui/ui-borders.vue'
import UI_Buttons from '@/views/pages/uiinterface/baseui/ui-buttons.vue'
import UI_Buttons_group from '@/views/pages/uiinterface/baseui/ui-buttons-group.vue'
import UI_Breadcrumb from '@/views/pages/uiinterface/baseui/ui-breadcrumb.vue'
import UI_Cards from '@/views/pages/uiinterface/baseui/ui-cards.vue'
import UI_Carousel from '@/views/pages/uiinterface/baseui/carousel/ui-carousel.vue'
import UI_Colors from '@/views/pages/uiinterface/baseui/ui-colors.vue'
import UI_Dropdowns from '@/views/pages/uiinterface/baseui/ui-dropdowns.vue'
import UI_Grid from '@/views/pages/uiinterface/baseui/ui-grid.vue'
import UI_Images from '@/views/pages/uiinterface/baseui/ui-images.vue'
import UI_Lightbox from '@/views/pages/uiinterface/baseui/lightbox/ui-lightbox.vue'
import UI_Media from '@/views/pages/uiinterface/baseui/ui-media.vue'
import UI_Modals from '@/views/pages/uiinterface/baseui/ui-modals.vue'
import UI_Offcanvas from '@/views/pages/uiinterface/baseui/ui-offcanvas.vue'
import UI_Pagination from '@/views/pages/uiinterface/baseui/ui-pagination.vue'
import UI_Popovers from '@/views/pages/uiinterface/baseui/ui-popovers.vue'
import UI_Progress from '@/views/pages/uiinterface/baseui/ui-progress.vue'
import UI_Placeholders from '@/views/pages/uiinterface/baseui/ui-placeholders.vue'
import UI_Rangeslider from '@/views/pages/uiinterface/advancedUI/ui-rangeslider.vue'
import Ui_Navtabs from '@/views/pages/uiinterface/baseui/ui-nav-tabs.vue'
import UI_Spinner from '@/views/pages/uiinterface/baseui/ui-spinner.vue'
import UI_Sweetalerts from '@/views/pages/uiinterface/baseui/ui-sweetalerts.vue'
import UI_Tooltips from '@/views/pages/uiinterface/baseui/ui-tooltips.vue'
import UI_Typography from '@/views/pages/uiinterface/baseui/ui-typography.vue'
import UI_Video from '@/views/pages/uiinterface/baseui/ui-video.vue'
import Icons from '@/views/pages/uiinterface/icons/ui-icons.vue'
import UI_Iconfontawesome from "@/views/pages/uiinterface/icons/icon-fontawesome.vue";
import UI_Iconfeather from "@/views/pages/uiinterface/icons/icon-feather.vue";
import UI_Iconionic from "@/views/pages/uiinterface/icons/icon-ionic.vue";
import UI_Iconmaterial from "@/views/pages/uiinterface/icons/icon-material.vue";
import UI_Iconpe7 from "@/views/pages/uiinterface/icons/icon-pe7.vue";
import UI_Iconsimpleline from "@/views/pages/uiinterface/icons/icon-simpleline.vue";
import UI_Iconthemify from "@/views/pages/uiinterface/icons/icon-themify.vue";
import UI_Iconweather from "@/views/pages/uiinterface/icons/icon-weather.vue";
import UI_Icontypicon from "@/views/pages/uiinterface/icons/icon-typicon.vue";
import UI_Iconflag from "@/views/pages/uiinterface/icons/icon-flag.vue";

// Authentication component

import LoginIndex from '@/views/pages/authentication/login-index.vue';
import ForgotPassword from '@/views/pages/authentication/forgot-password.vue';
import ForgotPasswordTwo from '@/views/pages/authentication/forgot-password-two.vue';
import ForgotPasswordThree from '@/views/pages/authentication/forgot-password-three.vue';
import ResetPassword from '@/views/pages/authentication/reset-password.vue';
import ResetPasswordTwo from '@/views/pages/authentication/reset-password-two.vue';
import ResetPasswordThree from '@/views/pages/authentication/reset-password-three.vue';
import EmailVerification from '@/views/pages/authentication/email-verification.vue';
import EmailVerificationTwo from '@/views/pages/authentication/email-verification-two.vue';
import EmailVerificationThree from '@/views/pages/authentication/email-verification-three.vue';
import TwoStepVerification from '@/views/pages/authentication/two-step-verification.vue';
import TwoStepVerificationTwo from '@/views/pages/authentication/two-step-verification-two.vue';
import TwoStepVerificationThree from '@/views/pages/authentication/two-step-verification-three.vue';
import LockScreen from '@/views/pages/authentication/lock-screen.vue';
import Error404 from '@/views/pages/authentication/error-404.vue';
import Error500 from '@/views/pages/authentication/error-500.vue';

import FormLayouts from '@/views/pages/uiinterface/forms/layouts/form-layouts.vue';

import packagesList from '@/views/pages/superadmin/packages/packages-list.vue';
import packagesGrid from '@/views/pages/superadmin/packages/packages-grid.vue';
import domainList from '@/views/pages/superadmin/domain/domain-list.vue';
import purchaseTransaction from '@/views/pages/superadmin/purchase/purchase-transaction.vue';
import TasksIndex from '@/views/pages/projects/task/tasks-index.vue';
import TaskBoard from '@/views/pages/projects/task/task-board.vue';
import TaskDetails from '@/views/pages/projects/task/task-details.vue';
import ContactsGrid from '@/views/pages/crm/contacts/contacts-grid.vue'
import ContactsList from '@/views/pages/crm/contacts/contacts-list.vue'
import ContactDetails from '@/views/pages/crm/contacts/contact-details.vue';
import AnalyticsList from '@/views/pages/crm/analytics/analytics-list.vue';
import HrmIndex from '@/views/pages/hrm/hrm-index.vue';
import HolidaysList from '@/views/pages/hrm/holidays/holidays-list.vue';
import LeavesAdmin from '@/views/pages/hrm/attendance/leaves/leaves-admin.vue';
import LeaveIndex from '@/views/pages/hrm/attendance/leaves/leave-index.vue';
import LeavesEmployee from '@/views/pages/hrm/attendance/leaves/leaves-employee.vue';
import LeaveSettings from '@/views/pages/hrm/attendance/leaves/leave-settings.vue';
import AttendanceIndex from '@/views/pages/hrm/attendance/attendance-index.vue';
import AttendanceAdmin from '@/views/pages/hrm/attendance/attendance-admin.vue';
import AttendanceEmployee from '@/views/pages/hrm/attendance/attendance-employee.vue';
import TimesheetsList from '@/views/pages/hrm/attendance/timesheets-list.vue';
import ScheduleTiming from '@/views/pages/hrm/attendance/schedule-timing.vue';
import OvertimeList from '@/views/pages/hrm/attendance/overtime-list.vue';
import PerformanceIndex from '@/views/pages/hrm/attendance/performance/performance-index.vue';
import PerformanceIndicator from '@/views/pages/hrm/attendance/performance/performance-indicator.vue';
import PerformanceReview from '@/views/pages/hrm/attendance/performance/performance-review.vue';
import PerformanceAppraisal from '@/views/pages/hrm/attendance/performance/performance-appraisal.vue';
import GoalTracking from '@/views/pages/hrm/attendance/performance/goal-tracking.vue';
import GoalType from '@/views/pages/hrm/attendance/performance/goal-type.vue';
import TrainingIndex from '@/views/pages/hrm/attendance/training/training-index.vue';
import TrainingList from '@/views/pages/hrm/attendance/training/training-list.vue';
import TrainersList from '@/views/pages/hrm/attendance/training/trainers-list.vue';
import TrainingType from '@/views/pages/hrm/attendance/training/training-type.vue';
import PromotionList from '@/views/pages/hrm/promotion/promotion-list.vue';
import ResignationList from '@/views/pages/hrm/resignation/resignation-list.vue';
import TerminationList from '@/views/pages/hrm/termination/termination-list.vue';
import RecuritmentIndex from '@/views/pages/recruitment/recuritment-index.vue';
import JobGrid from '@/views/pages/recruitment/jobs/job-grid.vue';
import JobList from '@/views/pages/recruitment/jobs/job-list.vue';
import CandidatesGrid from '@/views/pages/recruitment/candidates/candidates-grid.vue';
import CandidatesList from '@/views/pages/recruitment/candidates/candidates-list.vue';
import CandidatesKanban from '@/views/pages/recruitment/candidates/candidates-kanban.vue';
import RefferalsList from '@/views/pages/recruitment/refferals/refferals-list.vue';

import CategoriesList from '@/views/pages/finance-accounts/accounting/categories-list.vue';
import ContentIndex from '@/views/pages/content/content-index.vue';
import PagesList from '@/views/pages/content/pages-list.vue';
import LocationIndex from '@/views/pages/content/location/location-index.vue';
import CountriesList from '@/views/pages/content/location/countries-list.vue';
import StatesList from '@/views/pages/content/location/states-list.vue';
import CitiesList from '@/views/pages/content/location/cities-list.vue';
import FaqList from '@/views/pages/content/faq-list.vue';
import ReportsIndex from '@/views/pages/administration/reports/reports-index.vue';
import ExpensesReport from '@/views/pages/administration/reports/expenses-report.vue';
import InvoiceReport from '@/views/pages/administration/reports/invoice-report.vue';
import PaymentReport from '@/views/pages/administration/reports/payment-report.vue';
import ProjectReport from '@/views/pages/administration/reports/project-report.vue';
import TaskReport from '@/views/pages/administration/reports/task-report.vue';
import UserReport from '@/views/pages/administration/reports/user-report.vue';
import EmployeeReport from '@/views/pages/administration/reports/employee-report.vue';
import PayslipReport from '@/views/pages/administration/reports/payslip-report.vue';
import AttendanceReport from '@/views/pages/administration/reports/attendance-report.vue';
import LeaveReport from '@/views/pages/administration/reports/leave-report.vue';
import DailyReport from '@/views/pages/administration/reports/daily-report.vue';
import stockInReport from '@/views/pages/reports/inventory/stock-in.vue';
import stockOutReport from '@/views/pages/reports/inventory/stock-out.vue';
import currentStockReport from '@/views/pages/reports/inventory/current-stock.vue';
import purchaseOrderReport from '@/views/pages/reports/inventory/purchase-order.vue';
import deliveryChallanReport from '@/views/pages/reports/inventory/delivery-challan.vue';
import deliveryChallanReturnReport from '@/views/pages/reports/inventory/delivery-challan-return.vue';
import priceComparisonReport from '@/views/pages/reports/inventory/price-comparison.vue';

async function userPermission() {
  let raw = localStorage.getItem('auth_user');
  let auth_user;
  try {
    auth_user = raw ? JSON.parse(raw) : {};
  } catch (err) {
    localStorage.removeItem('auth_user');
    auth_user = {};
  }
  if (!auth_user.id) {
    return;
  }
  try {
    const response = await axios.get(`/users/${auth_user.id}`);
    const updatedUser = response.data.data;
    // Preserve installation_person from login response
    if (auth_user.installation_person && !updatedUser.installation_person) {
      updatedUser.installation_person = auth_user.installation_person;
    }
    localStorage.setItem('auth_user', JSON.stringify(updatedUser));
  } catch (error) {
    console.log(error.message);
  }
}

const routes = [
  {
    path: '/',
    name: 'login-index',
    component: LoginIndex,
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: dashboardIndex,
  },
  { 
    path: "/profile", 
    name: 'Profile',
    component: profileIndex 
  },
  { 
    path: "/notifications", 
    name: 'Notification',
    component: Notification 
  },
  {
   path: '/user-management',
   children: [
    { path: 'modules', component: ModuleList, name: 'module' },
    { path: 'roles-permissions', component: RolePermission, name: 'role-permission' },
    { path: 'users', component: Admin, name: 'user' }
   ] 
  }, 
  {path: '/industries', name: 'industries', component: Industries},
  {path: '/document-templates', name: 'document-templates', component: DocumentTemplates}, 
  {
    path: '/users',
    name: 'subadmin',
    component: SubAdmin,
    meta: { requiredModule: 'User', requiredAction: 'read' }
  },
  {
    path: '/crm',
    children: [
      { path: "leads-list", component: leadsList, name: "leads-list", meta: { requiredModule: 'Lead', requiredAction: 'read' } },
      { path: "leads-grid", component: leadsGrid, meta: { requiredModule: 'Lead', requiredAction: 'read' }  },
      { path: "leads-details/:id", component: leadsDetails, name: "leads-details", meta: { requiredModule: 'Lead', requiredAction: 'read' }  },
      { path: "leads/import/csv", component: importCsv, name: "lead-import-csv"},
      { path: "leads/import/IndiaMART", component: importIndiamart, name: "lead-import-indiamart", meta: { requiredModule: 'Lead', requiredAction: 'create' } },
      { path: "leads/import/TradeIndia", component: importTradeindia, name: "lead-import-tradeindia", meta: { requiredModule: 'Lead', requiredAction: 'create' } },
      { path: "leads/import/Aajjo", component: importAajjo, name: "lead-import-aajjo", meta: { requiredModule: 'Lead', requiredAction: 'create' } },
      { path: "leads/import/ExportersIndia", component: importExportersIndia, name: "lead-import-exportersindia", meta: { requiredModule: 'Lead', requiredAction: 'create' } },
      { path: "todays-followup", component: todaysFollowup, name: "todays-followup", meta: { requiredModule: 'Lead', requiredAction: 'read' } },
      { path: "customers", component: customers, meta: { requiredModule: 'Customer', requiredAction: 'read' } },
      { path: "customers-details/:id", component: customersDetails, name: "customers-details", meta: { requiredModule: 'Customer', requiredAction: 'read' }  },
      { path: "item-groups", component: itemGroups, name: "item-groups" },
      { path: "items", component: items, name: "items", meta: { requiredModule: 'Item', requiredAction: 'read' }  },
      { path: "items/import/csv", component: importItemCsv, name: "item-import-csv"},
      { path: "subscriptions", component: subscriptions, name: "subscriptions", meta: { requiredModule: 'Subscription', requiredAction: 'read' }  },
      { path: "customer-dispatches", component: customerDispatches, name: "customer-dispatches", meta: { requiredModule: 'Customer_Dispatch', requiredAction: 'read' } },
      { path: "site-inspections", component: siteInspections, name: "site-inspections", meta: { requiredModule: 'Site_Inspection', requiredAction: 'read' } },
    ]
  },
  {
    path: '/workspace',
    children: [
      { path: "projects", component: projects, name: "project", meta: { requiredModule: 'Project', requiredAction: 'read' } },
      { path: "project-details/:id", component: projectDetails, name: "project-details", meta: { requiredModule: 'Project', requiredAction: 'read' } },
      { path: "tasks", component: tasks, meta: { requiredModule: 'Project', requiredAction: 'read' }  },
    ]
  },  
  {
    path: '/sales',
    children: [
      // PROPOSALS
      { path: "proposals", component: proposals, name: "proposals", meta: { requiredModule: 'Proposal', requiredAction: 'read' }  },
      { path: "proposals/view/:public_token", component: viewProposal, name: "view-proposal"},
      // QUOTATIONS
      { path: "quotations", component: quotations, name: "quotations", meta: { requiredModule: 'Quotation', requiredAction: 'read' }  },
      { path: "quotations/view/:public_token", component: viewQuotation, name: "view-quotation"},
      { path: "quotations/preview/:id?", component: previewQuotation, name: "preview-quotation"},
      // PROFORMA INVOICE
      { path: "proforma-invoices", component: proformaInvoice, name: "proforma-invoices", meta: { requiredModule: 'Proforma_Invoice', requiredAction: 'read' }  },
      { path: "proforma-invoices/view/:public_token", component: viewProformaInvoice, name: "view-proforma-invoice"},
      { path: "proforma-invoices/preview/:id?", component: previewProforma, name: "preview-proforma-invoice"},
      // TAX INVOICE
      { path: "invoices", component: invoice, name: "invoices", meta: { requiredModule: 'Invoice', requiredAction: 'read' }  },
      { path: "invoices/view/:public_token", component: viewInvoice, name: "view-invoice"},
      { path: "invoices/preview/:id?", component: previewInvoice, name: "preview-invoice"},
    ]
  },
  {
    path: '/finance-accounts',
    children: [
      { path: "payments", component: payment, name: "payments", meta: { requiredModule: 'Payment', requiredAction: 'read' }  },
      { path: "payment-links", component: paymentLink, name: "payment-links", meta: { requiredModule: 'Payment', requiredAction: 'read' }  },
      { path: "zoho-payments", component: zohoPayment, name: "zoho-payments", meta: { requiredModule: 'Zoho_Payment', requiredAction: 'read' }  },
      { path: "zoho-payments/import/csv", component: importZohoPayment, name: "zoho-payments-import", meta: { requiredModule: 'Zoho_Payment', requiredAction: 'create' }  },
      { path: "zoho-payment-history", component: zohoPaymentHistory, name: "zoho-payment-history", meta: { requiredModule: 'Zoho_Payment', requiredAction: 'read' }  },
      { path: "samplings", component: sampling, name: "samplings", meta: { requiredModule: 'Sampling', requiredAction: 'read' } },
      { path: "sales-orders", component: salesOrder, name: "sales-orders", meta: { requiredModule: 'Sales_Order', requiredAction: 'read' } },
      { path: "sales-orders/packaging-list/:public_token", component: viewPackagingList, name: "packaging-list" }
    ]
  },
  {
    path: '/inventory',
    children: [
      { path: "vendors", component: vendor, name: "vendors", meta: { requiredModule: 'Vendor', requiredAction: 'read' }  },
      { path: "warehouses", component: warehouse, name: "warehouses", meta: { requiredModule: 'Warehouse', requiredAction: 'read' }  },
      { path: "purchase-orders", component: purchaseOrder, name: "purchase-orders", meta: { requiredModule: 'Purchase_Order', requiredAction: 'read' } },
      { path: "purchase-order/view/:public_token", component: viewPurchaseOrder, name: "view-purchase-order"},
      { path: "inward-stocks", component: inwardStock, name: "inward-stocks", meta: { requiredModule: 'Stock', requiredAction: 'read' } },
      { path: "import/csv", component: importInventory, name: "inventory-import", meta: { requiredModule: 'Stock', requiredAction: 'read' } },
      { path: "pending-variances", component: pendingVariance, name: "pending-variances", meta: { requiredModule: 'Stock', requiredAction: 'read' } },
      { path: "low-stock", component: lowStock, name: "low-stock", meta: { requiredModule: 'Stock', requiredAction: 'read' } },
      { path: "delivery-challans", component: deliveryChallan, name: "delivery-challans", meta: { requiredModule: 'Delivery_Challan', requiredAction: 'read' } },
      { path: "delivery-challans/view/:id", component: viewDeliveryChallan, name: "view-delivery-challan" },
      { path: "work-orders", component: workOrders, name: "work-orders" },
      { path: "delivery-challan-returns", component: deliveryChallanReturn, name: "delivery-challan-returns", meta: { requiredModule: 'Delivery_Challan', requiredAction: 'read' } },
      { path: "warehouse-items/:warehouse_id", component: warehouseItem, name: "warehouse-items", meta: { requiredModule: 'Stock', requiredAction: 'read' } }
    ]
  },
  {
    path: '/reports',
    children: [
      { path: "users/summary", component: userSummaryReport, name: "users_summary_report" },
      { path: "users/detailed", component: userDetailedReport, name: "users_detailed_report" },
      { path: "leads/summary", component: leadSummaryReport, name: "leads_summary_report" },
      { path: "leads/detailed", component: leadDetailedReport, name: "leads_detailed_report" },
      { path: "quotations/summary", component: quotationSummaryReport, name: "quotations_summary_report" },
      { path: "quotations/detailed", component: quotationDetailedReport, name: "quotations_detailed_report" },
      { path: "samplings/detailed", component: samplingDetailedReport, name: "sampling_detailed_report" },
      { path: "sales-orders/detailed", component: salesOrderDetailedReport, name: "sales_orders_detailed_report" },
      { path: "inventory/stock-in", component: stockInReport, name: "stock_in_report", meta: { requiredModule: 'Report_Inventory', requiredAction: 'read' } },
      { path: "payments/detailed", component: paymentDetailedReport, name: "payments_detailed_report" },
      { path: "inventory/current-stock", component: currentStockReport, name: "current_stock_report", meta: { requiredModule: 'Report_Inventory', requiredAction: 'read' } },
      { path: "inventory/stock-out", component: stockOutReport, name: "stock_out_report", meta: { requiredModule: 'Report_Inventory', requiredAction: 'read' } },
      { path: "inventory/purchase-order", component: purchaseOrderReport, name: "purchase_order_report", meta: { requiredModule: 'Report_Inventory', requiredAction: 'read' } },
      { path: "inventory/delivery-challan", component: deliveryChallanReport, name: "delivery_challan_report", meta: { requiredModule: 'Report_Inventory', requiredAction: 'read' } },
      { path: "inventory/delivery-challan-returns", component: deliveryChallanReturnReport, name: "delivery_challan_return_report", meta: { requiredModule: 'Report_Inventory', requiredAction: 'read' } },
      { path: "inventory/price-comparison", component: priceComparisonReport, name: "price_comparison_report", meta: { requiredModule: 'Report_Inventory', requiredAction: 'read' } }
      // { path: "inventory/stock-in", component: stockInReport, name: "stock_in_report"  ,  meta: { requiredModule: 'Stock', requiredAction: 'read' } },
      // { path: "inventory/stock-out", component: stockOutReport, name: "stock_out_report",  meta: { requiredModule: 'Stock', requiredAction: 'read' }  },
      // { path: "inventory/purchase-order", component: purchaseOrderReport, name: "purchase_order_report", meta: { requiredModule: 'Purchase_Order', requiredAction: 'read' } },
      // { path: "inventory/delivery-challan", component: deliveryChallanReport, name: "delivery_challan_report", meta: { requiredModule: 'Delivery_Challan', requiredAction: 'read' } },
      // { path: "inventory/delivery-challan-returns", component: deliveryChallanReturnReport, name: "delivery_challan_return_report", meta: { requiredModule: 'Delivery_Challan', requiredAction: 'read' } },
      // { path: "inventory/price-comparison", component: priceComparisonReport, name: "price_comparison_report", meta: { requiredModule: 'Stock', requiredAction: 'read' } }
    ]
  },
  {
    path: '/general-settings',
    children: [
      { path: "business-settings", component: businessSettings },
      { path: "bank-details", component: bankDetails },
      { path: "branch-details", component: branchDetails },
    ]
  },
  {
    path: '/crm-settings',
    children: [
      { path: 'lead-stages', component: LeadStage, name: 'lead-stage' },
      { path: 'lead-sources', component: LeadSource, name: 'lead-source' },
      { path: 'lead-assignment-rule', component: LeadAssignmentRule, name: 'lead-assignment-rule' },
      { path: 'lead-assignment-location-rule', component: LeadAssignmentLocationRule, name: 'lead-assignment-location-rule' },
      { path: 'project-pipelines', component: ProjectPipeline, name: 'project-pipeline' },
    ]
  },
  {
    path: '/financial-settings',
    children: [
      { path: 'taxes', component: Tax, name: 'tax' },
      { path: "currencies", component: currenciesSettings },
    ]
  },
  {
    path: '/document-settings',
    children: [
      { path: 'proposal', component: proposalSetting, name: 'proposal-settings' },
      { path: 'quotation', component: quotationSetting, name: 'quotation-settings' },
      { path: 'proforma', component: proformaSetting, name: 'proforma-settings' },
      { path: 'invoice', component: invoiceSetting, name: 'invoice-settings' },
      { path: 'sales-order', component: salesOrderSettings, name: 'sales-order-settings' },
      { path: 'sampling', component: samplingSettings, name: 'sampling-settings' }
    ]
  },
  {
    path: '/app-settings',
    children: [
      { path: 'app-store', component: appStore, name: 'app-store' },
    ]
  },
  {
    path: '/others-settings',
    children: [
      { path: "configurations", component: configuration },
      { path: "roles", component: UserRolePermission },
      { path: "whatsapp-followup-templates", component: WhatsappFollowupTemplates },
      { path: "brands", component: Brands},
      { path: "engineer", component: Engineer },
      { path: "sales-executives", component: salesExecutives },
      { path: "internal-consumptions", component: internalConsumptions },
      { path: "site-inspectors", component: siteInspectors },
      { path: "store-persons", component: storePersons },
      { path: "installation-persons", component: installationPersons },
      { path: "storage-settings", component: storageSettings },
      { path: "ban-ip-address", component: banIpAddress },
      { path: "backup", component: backupSettings },
      { path: "clear-cache", component: clearCache },
    ]
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: ForgotPassword
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: ResetPassword
  },
  {
    path: '/email-verification',
    name: 'email-verification',
    component: EmailVerification
  },
  {
    path: '/email-verification-2',
    name: 'email-verification-two',
    component: EmailVerificationTwo
  },
  {
    path: '/email-verification-3',
    name: 'email-verification-three',
    component: EmailVerificationThree
  },
  {
    path: '/two-step-verification',
    name: 'two-step-verification',
    component: TwoStepVerification
  },
  {
    path: '/two-step-verification-2',
    name: 'two-step-verification-two',
    component: TwoStepVerificationTwo
  },
  {
    path: '/two-step-verification-3',
    name: 'two-step-verification-three',
    component: TwoStepVerificationThree
  },
  {
    path: '/lock-screen',
    name: 'lock-screen',
    component: LockScreen
  },
  {
    path: '/error-404',
    name: 'error-404',
    component: Error404
  },
  {
    path: '/error-500',
    name: 'error-500',
    component: Error500
  },
  {
    path: '/website-settings',
    component: websiteSettings,
    children: [
      { path: '', redirect: '/website-settings/bussiness-settings' },
      { path: "seo-settings", component: seoSettings },
      { path: "localization-settings", component: localizationSettings },
      { path: "prefixes", component: prefixes },
      { path: "preferences", component: preferences },
      { path: "appearance", component: appearance },
      { path: "authentication-settings", component: authenticationSettings },
      { path: "ai-settings", component: aiSettings },
    ]
  },
  
  
  {
    path: '/system-settings',
    component: systemSettings,
    children: [
      { path: '', redirect: '/system-settings/email-settings' },
      { path: "otp-settings", component: otpSettings },
      { path: "email-settings", component: emailSettings },
      { path: "email-template", component: emailTemplate },
      { path: "sms-settings", component: smsSettings },
      { path: "sms-template", component: smsTemplate },
      { path: "gdpr", component: gdprSettings },
      { path: "maintenance-mode", component: maintenanceMode },
    ]
  },
  {
    path: '/supports',
    component: helpSupports,
    children: [
      { path: '', redirect: '/supports/knowledgebase' },
      { path: "knowledgebase", component: knowledgebaseIndex },
      { path: "knowledgebase-view", component: knowledgebaseView },
      { path: "knowledgebase-details", component: knowledgebaseDetails },
    ]
  },
  {
    path: '/asset',
    component: assetsIndex,
    children: [
      { path: '', redirect: '/asset/assets' },
      { path: "assets", component: assetsList },
      { path: "asset-categories", component: assetsCategories },
    ]
  },
  {
    path: '/layouts',
    component: layoutIndex,
    children: [
      { path: '', redirect: '/layouts/layout-horizontal' },
      { path: "layout-horizontal", component: layoutHorizontal },
      { path: "layout-detached", component: layoutDetached },
      { path: "layout-modern", component: layoutModern },
      { path: "layout-two-column", component: layoutTwocolum },
      { path: "layout-hovered", component: layoutHovered },
      { path: "layout-box", component: layoutBox },
      { path: "layout-horizontal-single", component: layoutHorizontalSingle },
      { path: "layout-horizontal-overlay", component: layoutHorizontalOverlay },
      { path: "layout-horizontal-box", component: layoutHorizontalBox },
      { path: "layout-horizontal-sidemenu", component: layoutHorizontalSidemenu },
      { path: "layout-vertical-transparent", component: layoutVerticalTransparent },
      { path: "layout-without-header", component: layoutWithoutHeader },
      { path: "layout-rtl", component: layoutRtl },
      { path: "layout-dark", component: layoutDark },
    ]
  },
  {
    path: '/pages',
    component: pagesIndex,
    children: [
      { path: '', redirect: '/pages/starter' },
      { path: "starter", component: starterIndex },
      { path: "gallery", component: galleryIndex },
      { path: "search-result", component: searchResult },
      { path: "timeline", component: timelineIndex },
      { path: "pricing", component: pricingIndex },
      { path: "coming-soon", component: comingSoon },
      { path: "under-maintenance", component: underMaintenance },
      { path: "under-construction", component: underConstruction },
      { path: "api-keys", component: apiKeys },
      { path: "terms-condition", component: termsCondition },
      { path: "privacy-policy", component: privacyPolicy },
    ]
  },
  {
    path: '/payroll',
    component: payrollIndex,
    children: [
      { path: '', redirect: '/payroll/employee-salary' },
      { path: "employee-salary", component: employeeSalary },
      { path: "payslip", component: payslipIndex },
      { path: "payroll", component: payrollAdditions },
      { path: "payroll-overtime", component: payrollOvertime },
      { path: "payroll-deduction", component: payrollDeduction },
    ]
  },
  {
    path: '/accounting',
    component: accountingIndex,
    children: [
      { path: '', redirect: '/accounting/budgets' },
      { path: "budgets", component: budgetsIndex },
      { path: "budget-expenses", component: budgetsExpenses },
      { path: "budget-revenues", component: budgetsRevenues },
      { path: "categories", component: CategoriesList },
    ]
  },
  {
    path: '/reports',
    component: ReportsIndex,
    children: [
      { path: '', redirect: '/reports/expenses-report' },
      { path: "expenses-report", component: ExpensesReport },
      { path: "invoice-report", component: InvoiceReport },
      { path: "payment-report", component: PaymentReport },
      { path: "project-report", component: ProjectReport },
      { path: "task-report", component: TaskReport },
      { path: "user-report", component: UserReport },
      { path: "employee-report", component: EmployeeReport },
      { path: "payslip-report", component: PayslipReport },
      { path: "attendance-report", component: AttendanceReport },
      { path: "leave-report", component: LeaveReport },
      { path: "daily-report", component: DailyReport },
    ]
  },
  {
    path: '/location',
    component: LocationIndex,
    children: [
      { path: '', redirect: '/location/countries' },
      { path: "countries", component: CountriesList },
      { path: "states", component: StatesList },
      { path: "cities", component: CitiesList },
    ]
  },
  {
    path: '/recuritment',
    component: RecuritmentIndex,
    children: [
      { path: '', redirect: '/recuritment/job-grid' },
      { path: "job-grid", component: JobGrid },
      { path: "job-list", component: JobList },
      { path: "candidates-grid", component: CandidatesGrid },
      { path: "candidates", component: CandidatesList },
      { path: "candidates-kanban", component: CandidatesKanban },
      { path: "refferals", component: RefferalsList },
    ]
  },
  {    
    path: '/hrm',
    component: HrmIndex,
    children: [
      { path: '', redirect: '/hrm/holidays' },
      { path: "holidays", component: HolidaysList },
      { path: "promotion", component: PromotionList }, 
      { path: "resignation", component: ResignationList }, 
      { path: "termination", component: TerminationList }, 
    ]
  },
  {    
    path: '/training',
    component: TrainingIndex,
    children: [
      { path: '', redirect: '/training/training-list' },
      { path: "training-list", component: TrainingList },
      { path: "trainers", component: TrainersList },
      { path: "training-type", component: TrainingType },
    ]
  },
  {    
    path: '/performance',
    component: PerformanceIndex,
    children: [
      { path: '', redirect: '/performance/performance-indicator' },
      { path: "performance-indicator", component: PerformanceIndicator },
      { path: "performance-review", component: PerformanceReview },
      { path: "performance-appraisal", component: PerformanceAppraisal },
      { path: "goal-tracking", component: GoalTracking },
      { path: "goal-type", component: GoalType },
    ]
  },
  {
    path: '/attendance',
    component: AttendanceIndex,
    children: [
      { path: '', redirect: '/attendance/attendance-admin' },
      { path: "attendance-admin", component: AttendanceAdmin },
      { path: "attendance-employee", component: AttendanceEmployee },
      { path: "timesheets", component: TimesheetsList },
      { path: "schedule-timing", component: ScheduleTiming },
      { path: "overtime", component: OvertimeList }      
    ]
  },
  {
    path: '/leave',
    component: LeaveIndex,
    children: [
      { path: '', redirect: '/leave/leaves-admin' },
      { path: "leaves-admin", component: LeavesAdmin },
      { path: "leaves-employee", component: LeavesEmployee },
      { path: "leave-settings", component: LeaveSettings },
    ]
  },
  {
    path: '/tickets',
    component: ticketsIndex,
    children: [
      { path: '', redirect: '/tickets/ticket' },
      { path: "ticket", component: ticketList },
      { path: "tickets-grid", component: ticketsGrid },
      { path: "tickets-details", component: ticketsDetails },
    ]
  },
  {
    path: '/employee',
    component: employeesIndex,
    children: [
      { path: '', redirect: '/employee/employee-list' },
      { path: "employee-list", component: employeesList },
      { path: "employee-grid", component: employeesGrid },
      { path: "employee-details", component: employeeDetails },
      { path: "departments", component: employeeDepartment },
      { path: "designations", component: employeeDesignations },
      { path: "policy", component: employeePolicy },
    ]
  },
  {
    path: '/applications',
    component: applicationIndex,
    children: [
      { path: '', redirect: '/applications/chat' },
      { path: "chat", component: chatIndex },
      { path: "events", component: calendarIndex },
      { path: "email", component: emailIndex },
      { path: "email-reply", component: emailReply },
      { path: "todo", component: todoIndex },
      { path: "todo-list", component: todoList },
      { path: "notes", component: notesIndex },
      { path: "social-feed", component: socialFeed },
      { path: "invoices", component: invoicesApp },
      { path: "add-invoices", component: addInvoices },
      { path: "edit-invoices", component: editInvoices },
      { path: "invoice-details", component: invoiceDetails },
      { path: "file-manager", component: fileManager },
      { path: "kanban-view", component: kanbanView },
    ]
  },
  {
    path: '/calls',
    component: applicationIndex,
    children: [
      { path: '', redirect: '/calls/voice-call' },
      { path: "voice-call", component: voiceCall },
      { path: "video-call", component: videoCall },
      { path: "outgoing-call", component: outgoingCall },
      { path: "incoming-call", component: incomingCall },
      { path: "call-history", component: callHistory },
    ]
  },
  {
    path: '/icons',
    component: Icons,
    children: [
      { path: '', redirect: '/icons/icon-fontawesome' },
      { path: "icon-fontawesome", component: UI_Iconfontawesome },
      { path: "icon-feather", component: UI_Iconfeather },
      { path: "icon-ionic", component: UI_Iconionic },
      { path: "icon-material", component: UI_Iconmaterial },
      { path: "icon-pe7", component: UI_Iconpe7 },
      { path: "icon-simpleline", component: UI_Iconsimpleline },
      { path: "icon-themify", component: UI_Iconthemify },
      { path: "icon-weather", component: UI_Iconweather },
      { path: "icon-typicon", component: UI_Icontypicon },
      { path: "icon-flag", component: UI_Iconflag },
    ]
  },
  {
    path: '/baseui',
    component: BaseUi,
    children: [
      { path: '', redirect: '/baseui/ui-alerts' },
      { path: "ui-alerts", component: UI_Alerts },
      { path: "ui-accordion", component: UI_Accordion },
      { path: "ui-avatar", component: UI_Avatar },
      { path: "ui-badges", component: UI_Badges },
      { path: "ui-borders", component: UI_Borders },
      { path: "ui-buttons", component: UI_Buttons },
      { path: "ui-buttons-group", component: UI_Buttons_group },
      { path: "ui-breadcrumb", component: UI_Breadcrumb },
      { path: "ui-cards", component: UI_Cards },
      { path: "ui-carousel", component: UI_Carousel },
      { path: "ui-colors", component: UI_Colors },
      { path: "ui-dropdowns", component: UI_Dropdowns },
      { path: "ui-grid", component: UI_Grid },
      { path: "ui-images", component: UI_Images },
      { path: "ui-lightbox", component: UI_Lightbox},
      { path: "ui-media", component: UI_Media},
      { path: "ui-modals", component: UI_Modals},
      { path: "ui-offcanvas", component: UI_Offcanvas},
      { path: "ui-pagination", component: UI_Pagination},
      { path: "ui-popovers", component: UI_Popovers},
      { path: "ui-progress", component: UI_Progress},
      { path: "ui-placeholders", component: UI_Placeholders},
      { path: "ui-nav-tabs", component: Ui_Navtabs},
      { path: "ui-spinner", component: UI_Spinner},
      { path: "ui-sweetalerts", component: UI_Sweetalerts},
      { path: "ui-tooltips", component: UI_Tooltips},
      { path: "ui-typography", component: UI_Typography},
      { path: "ui-video", component: UI_Video},
    ]
  },
  {
    path: '/advancedui',
    component: Advancedui,
    children: [
      { path: '', redirect: '/advancedui/ui-ribbon' },
      { path: "ui-ribbon", component: UI_Ribbon },
      { path: "ui-clipboard", component: UI_Clipboard },
      { path: "ui-drag-drop", component: UI_Drag_Drop },
      { path: "ui-text-editor", component: UI_Text_Editor },
      { path: "ui-counter", component: UI_Counter },
      { path: "ui-scrollbar", component: UI_Scrollbar },
      { path: "ui-rating", component: UI_Rating },
      { path: "ui-stickynote", component: UI_Stickynote },
      { path: "ui-rangeslider", component: UI_Rangeslider},
      { path: "ui-timeline", component: UI_Timeline }
    ]
  },
  {
    path: '/tables',
    component: Tables,
    children: [
      { path: '', redirect: '/tables/data-tables' },
      { path: "data-tables", component: Data_Tables },
      { path: "tables-basic", component: Tables_Basic }
    ]
  },
  {
    path: '/charts',
    component: Charts,
    children: [
      { path: '', redirect: '/charts/chart-apex' },
      { path: "chart-apex", component: Chartapex },
      { path: "chart-c3", component: Chartc3 },
      { path: "chart-flot", component: Chartflot },
      { path: "chart-js", component: Chartjs },
      { path: "chart-morris", component: Chartmorris }
    ]
  },
  {
    path: '/form-elements',
    component: FormElements,
    children: [
      { path: '', redirect: '/form-elements/form-basic-inputs' },
      { path: "form-basic-inputs", component: Formbasicinput },
      { path: "form-checkbox-radios", component: Formcheckboxradios },
      { path: "form-grid-gutters", component: Formgridgutters },
      { path: "form-input-groups", component: FormInput },
      { path: "form-select", component: Formselect },
      { path: "form-mask", component: Formmask },
      { path: "form-fileupload", component: Formfileupload },
    ]
  },
  {
    path: '/form-layouts',
    component: FormLayouts,
    children: [
      { path: '', redirect: '/form-layouts/form-horizontal' },
      { path: "form-horizontal", component: FormHorizontal },
      { path: "form-vertical", component: Formvertical },
      { path: "form-floating-labels", component: Formfloatinglabels },
    ]
  },
  {
    path: '/forms',
    component: Forms,
    children: [
      { path: '', redirect: '/forms/form-validation' },
      { path: "form-validation", component: Formvalidation },
      { path: "form-select2", component: Formselect2 },
      { path: "form-wizard", component: Formwizard },
    ]
  },
  ];
export const router = createRouter({
    history: createWebHistory('/'),
    linkActiveClass: 'active',
    routes,
}); 


router.afterEach((to) => {
  if (to.name === "layout-rtl") {
    document.body.classList.add("layout-mode-rtl");
  } else {
    document.body.classList.remove("layout-mode-rtl");
  }
});

let lastUserFetch = 0;
const USER_FETCH_INTERVAL = 5 * 60 * 1000;

router.beforeEach((to, from, next) => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
  
  const is_auth = isAuthenticated();

  if(is_auth){
    const now = Date.now()
    if(now - lastUserFetch > USER_FETCH_INTERVAL){
      lastUserFetch = now
      userPermission();
    }
  }

  // If user is not authenticated and trying to access anything except login
 const publicRoutes = ['view-proposal', 'view-quotation', 'view-proforma-invoice', 'view-invoice', 'packaging-list', 'reset-password', 'forgot-password'];
  if(!is_auth && to.path !== '/' && !publicRoutes.includes(to.name)){
    return next('/');
  }

  // If user is authenticated and trying to access the login page
  if(is_auth && to.path === '/'){
    return next('/dashboard');
  }

  let auth_user = JSON.parse(localStorage.getItem('auth_user') || '{}');

  // === NotificationService Integration ===  ← ADD THIS BLOCK
  const shouldEnableNotifications = !!localStorage.getItem('auth_token') && !publicRoutes.includes(to.name);
  if (shouldEnableNotifications) {
    NotificationService.enable();
  } else {
    NotificationService.disable();
  }
  // === END NotificationService ===

  // === Permission Check Logic ===
  // If the route has a permission requirement
  if (to.meta && to.meta.requiredModule) {
    const permissions = (auth_user.role && auth_user.role.permissions) ? auth_user.role.permissions : [];
    const modPerm = permissions.find(
      p => p.module && p.module.name === to.meta.requiredModule
    );

    // Default to 'read' if not specified
    const action = to.meta.requiredAction || 'read';

    // If user does **not** have required permission, redirect to dashboard
    if (!modPerm || !modPerm[action]) {
      return next('/dashboard');
    }
  }

  next();
});

export default router;